import { GlobalIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from "shared/components/Tooltip";
import { useInboxEmbed } from "../context/useInboxEmbed";
import type { MessageTranslation } from "../hooks/useMessageTranslation";
import type { TranslationLanguage } from "../types";

const translateLabelFor = (language: TranslationLanguage): string =>
  language === "es" ? "Translate to Spanish" : "Translate to English";

export const MessageTranslateButton = ({
  translation
}: {
  translation: MessageTranslation;
}) => {
  const embed = useInboxEmbed();
  const { targetLanguage, showingTranslation, isTranslating } = translation;

  if (!targetLanguage) return null;

  const label = showingTranslation
    ? "Show original"
    : translateLabelFor(targetLanguage);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={isTranslating ? "Translating" : label}
          aria-pressed={showingTranslation}
          disabled={isTranslating}
          onClick={
            showingTranslation
              ? translation.showOriginal
              : translation.translate
          }
          className={cx(
            "-my-0.5 flex size-5 shrink-0 items-center justify-center rounded-md transition-colors disabled:cursor-default",
            showingTranslation
              ? "bg-primary-50 text-primary-500"
              : "text-content-300 hover:bg-alpha-40"
          )}
        >
          {isTranslating ? (
            <span className="size-3.5 animate-spin rounded-full border-2 border-alpha-200 border-t-primary-500" />
          ) : (
            <HugeiconsIcon icon={GlobalIcon} size={14} strokeWidth={1.75} />
          )}
        </button>
      </TooltipTrigger>
      <Show if={!isTranslating}>
        <TooltipContent
          className="z-50 rounded-lg px-3 py-2 text-xs font-medium text-white"
          style={embed ? { zIndex: embed.modalZIndex } : undefined}
        >
          {label}
        </TooltipContent>
      </Show>
    </Tooltip>
  );
};
